import React from 'react';
import { Section } from './ui/Section';
export function TheProblem() {
  return <Section background="beige" className="text-center" data-id="element-133">
      <h2 className="text-3xl md:text-4xl font-serif text-[#4A4238] mb-8" data-id="element-134">
        The Real Problem
      </h2>

      <div className="prose prose-lg mx-auto text-[#4A4238]" data-id="element-135">
        <p className="mb-6" data-id="element-136">
          The problem isn't that you're messy. Or unmotivated. Or "bad at
          routines."
        </p>
        <p className="text-xl font-medium mb-8" data-id="element-137">
          The problem is that your day is{' '}
          <span className="border-b-2 border-[#7BA99E]" data-id="element-138">fragmented</span>.
        </p>

        <div className="bg-[#FAF7F2] p-8 rounded-xl shadow-sm my-10 text-left" data-id="element-139">
          <p className="mb-4 font-medium text-[#8C7E6E] uppercase tracking-wider text-sm" data-id="element-140">
            Most solutions require:
          </p>
          <ul className="space-y-3 list-none pl-0" data-id="element-141">
            {['Continuity', 'Energy', 'Time blocks', "Executive function you don't currently have"].map((item, i) => <li key={i} className="flex items-center text-[#4A4238]" data-id="element-142">
                <span className="w-2 h-2 bg-[#D6C0A8] rounded-full mr-3" data-id="element-143"></span>
                {item}
              </li>)}
          </ul>
        </div>

        <p className="text-lg italic text-[#8C7E6E]" data-id="element-144">
          So you try to catch up… and you can't… and then you spiral… and
          everything feels louder.
        </p>
      </div>
    </Section>;
}